import { render, staticRenderFns } from "./WashingList.vue?vue&type=template&id=897cd43c&scoped=true&"
import script from "./WashingList.vue?vue&type=script&lang=ts&"
export * from "./WashingList.vue?vue&type=script&lang=ts&"
import style0 from "./WashingList.vue?vue&type=style&index=0&id=897cd43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897cd43c",
  null
  
)

export default component.exports